import { Component, viewChild } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

import { HeaderComponent } from '../../../components/header/header.component'
import { AuthorsListComponent } from './components/authors-list/authors-list.component'

@Component({
  selector: 'dhp-authors-overview',
  templateUrl: './authors-overview.component.html',
  styleUrls: ['./authors-overview.component.scss'],
  imports: [HeaderComponent, AuthorsListComponent, TranslatePipe],
})
export class AuthorsOverviewComponent {
  readonly authorsList = viewChild.required(AuthorsListComponent)
  selectedMagazineIds: number[] = []

  onSearch(term: string): void {
    const authorsList = this.authorsList()
    if (authorsList) {
      authorsList.searchTerm = term
    }
  }

  onMagazinesChange(magazineIds: number[]): void {
    this.selectedMagazineIds = magazineIds
  }
}
